<template>
  <section v-if="!useV2026MessageTemplateCategorySettings" class="p-3">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <div class="mb-3">
            <router-link to="/settings/message-template">ตอบด้วยคีย์ลัด</router-link> / จัดการหมวดหมู่คีย์ลัด
          </div>
          <button class="btn btn-primary" @click="addCategory">เพิ่มหมวดหมู่</button>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
              <tr class="table-light">
                <th scope="col">#</th>
                <th scope="col">ชื่อหมวดหมู่</th>
                <th scope="col">Created At</th>
                <th scope="col">Updated At</th>
                <th scope="col">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr class="table-light" v-for="(item, index) in categories" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.created_at | prettyDate }}</td>
                <td>{{ item.updated_at | prettyDate }}</td>
                <td>
                  <button class="btn btn-warning" @click.prevent="editCategory(item)">แก้ไข</button>
                  <button class="btn btn-danger ml-2" @click.prevent="deleteCategory(item)">ลบ</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal -->
    <b-modal ref="categoryModal"
             :title="mode === 'create' ? 'สร้างหมวดหมู่' : 'แก้ไขหมวดหมู่'">
      <div class="row">
        <div class="col-12">
          <form ref="form" @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="">ชื่อหมวดหมู่</label>
              <input type="text" class="form-control" required v-model="category.name">
            </div>
          </form>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <button class="btn btn-primary float-right" @click.prevent="handleSubmit">SUBMIT</button>
        </div>
      </template>
    </b-modal>
  </section>

  <section v-else class="v2026-cat">
    <nav class="v2026-cat-crumb" aria-label="เส้นทางหน้า">
      <RouterLink :to="{ name: 'message-template' }" class="v2026-cat-crumb__link">ตอบด้วยคีย์ลัด</RouterLink>
      <span class="v2026-cat-crumb__sep" aria-hidden="true">/</span>
      <span aria-current="page">จัดการหมวดหมู่คีย์ลัด</span>
    </nav>
    <h4 class="v2026-cat-title">จัดการหมวดหมู่คีย์ลัด</h4>

    <div class="v2026-cat-toolbar">
      <button ref="addBtn" type="button" class="v2026-cat-btn-primary" @click="openCreateV2026">
        <span class="v2026-cat-ico v2026-cat-ico--plus" aria-hidden="true"></span>เพิ่มหมวดหมู่
      </button>
      <LoadingV2026 v-if="isLoading && categories.length" label="กำลังโหลด"/>
    </div>

    <div ref="catList"
         class="v2026-cat-list"
         :class="{ 'is-narrow': isNarrow, 'is-empty': !showRows }"
         :aria-busy="isLoading ? 'true' : 'false'">
      <div v-if="showRows" class="v2026-cat-head" aria-hidden="true">
        <span>ชื่อหมวดหมู่</span>
        <span v-if="!isNarrow">สร้างเมื่อ</span>
        <span></span>
      </div>

      <!-- Keyed by the real id, not the index: delete removes rows from the middle. -->
      <div v-for="item in categories" :key="item.id" class="v2026-cat-row">
        <div class="v2026-cat-name" :title="item.name">
          <span class="v2026-cat-sr">ชื่อหมวดหมู่: </span>{{ item.name }}
        </div>
        <div class="v2026-cat-date">
          <span class="v2026-cat-sr">สร้างเมื่อ: </span>
          <span v-if="isNarrow" aria-hidden="true">สร้างเมื่อ </span>{{ createdAtText(item) }}
        </div>
        <div class="v2026-cat-actions">
          <button type="button"
                  class="v2026-cat-btn-row"
                  :aria-label="'แก้ไขหมวดหมู่ ' + item.name"
                  @click="openEditV2026(item)">
            <span class="v2026-cat-ico v2026-cat-ico--edit" aria-hidden="true"></span>แก้ไข
          </button>
          <button type="button"
                  class="v2026-cat-btn-row v2026-cat-btn-row--danger"
                  :disabled="confirm.busy && !!confirm.target && confirm.target.id === item.id"
                  :aria-label="'ลบหมวดหมู่ ' + item.name"
                  @click="openDeleteV2026(item)">
            <span class="v2026-cat-ico v2026-cat-ico--trash" aria-hidden="true"></span>ลบ
          </button>
        </div>
      </div>
    </div>

    <div v-if="isLoading && !categories.length" class="v2026-cat-loading" role="status">
      <LoadingV2026 label="กำลังโหลด"/>
    </div>

    <div v-else-if="loadError && !categories.length" class="v2026-cat-empty" role="status">
      <span class="v2026-cat-empty__ico" aria-hidden="true"></span>
      <div class="v2026-cat-empty__title">โหลดหมวดหมู่ไม่สำเร็จ</div>
      <div class="v2026-cat-empty__msg">{{ loadError }}</div>
      <button type="button"
              class="v2026-cat-btn-ghost v2026-cat-empty__act"
              @click="fetchV2026">ลองใหม่</button>
    </div>

    <div v-else-if="!isLoading && !categories.length" class="v2026-cat-empty" role="status">
      <span class="v2026-cat-empty__ico" aria-hidden="true"></span>
      <div class="v2026-cat-empty__title">ยังไม่มีหมวดหมู่คีย์ลัด</div>
      <div class="v2026-cat-empty__msg">เพิ่มหมวดหมู่เพื่อจัดกลุ่มคีย์ลัดให้หาง่ายขึ้น</div>
      <button type="button"
              class="v2026-cat-btn-ghost v2026-cat-empty__act"
              @click="openCreateV2026">เพิ่มหมวดหมู่</button>
    </div>

    <BaseModal :open="modalOpen" maxWidth="480px" :closeOnBackdrop="false" @close="closeModalV2026">
      <div ref="catModal"
           class="v2026-catm"
           role="dialog"
           aria-modal="true"
           aria-labelledby="v2026-catm-title"
           @keydown.tab="trapTab($event, 'catModal')">
        <div class="v2026-catm__head">
          <span id="v2026-catm-title" class="v2026-catm__title">
            {{ mode === 'create' ? 'สร้างหมวดหมู่' : 'แก้ไขหมวดหมู่' }}
          </span>
          <button type="button" class="v2026-catm__x" aria-label="ปิด" @click="closeModalV2026">×</button>
        </div>

        <div class="v2026-catm__body">
          <label class="v2026-catm__label" for="v2026-cat-name">
            ชื่อหมวดหมู่<span class="v2026-catm__req" aria-hidden="true"> *</span>
          </label>
          <input id="v2026-cat-name"
                 ref="catNameInput"
                 type="text"
                 maxlength="255"
                 class="v2026-catm__input"
                 :class="{ 'is-invalid': !!nameError }"
                 placeholder="เช่น ทักทายลูกค้า"
                 :aria-invalid="nameError ? 'true' : 'false'"
                 :aria-describedby="nameError ? 'v2026-cat-name-err' : null"
                 v-model="category.name"
                 @input="nameError = ''"
                 @keyup.enter="submitV2026">
          <div v-if="nameError" id="v2026-cat-name-err" class="v2026-catm__err">{{ nameError }}</div>
        </div>

        <div class="v2026-catm__foot">
          <button type="button" class="v2026-cat-btn-ghost" @click="closeModalV2026">ยกเลิก</button>
          <button type="button"
                  class="v2026-cat-btn-primary"
                  :disabled="isSaving"
                  @click="submitV2026">{{ isSaving ? 'กำลังโหลด...' : 'บันทึก' }}</button>
        </div>
      </div>
    </BaseModal>

    <BaseConfirm :open="confirm.open"
                 :title="'ลบหมวดหมู่ “' + (confirm.target ? confirm.target.name : '') + '” ?'"
                 message="หมวดหมู่นี้จะถูกลบถาวรและกู้คืนไม่ได้ คีย์ลัดที่อยู่ในหมวดหมู่นี้จะไม่ถูกลบ แต่จะกลายเป็นคีย์ลัดที่ไม่มีหมวดหมู่"
                 confirmLabel="ลบ"
                 cancelLabel="ยกเลิก"
                 variant="danger"
                 :busy="confirm.busy"
                 @confirm="acceptDeleteV2026"
                 @cancel="cancelDeleteV2026"/>

    <BaseToast :open="toast.open"
               :variant="toast.variant"
               :title="toast.title"
               :message="toast.message"
               :autoHideDelay="toast.variant === 'danger' ? 5000 : 2500"
               @close="toast.open = false"/>
  </section>
</template>

<script>
import axios from 'axios'
import BaseModal from '../components/coversation/BaseModal'
import BaseConfirm from '../components/coversation/BaseConfirm'
import BaseToast from '../components/coversation/BaseToast'
import LoadingV2026 from '../components/coversation/LoadingV2026'

export default {
  name: 'MessageTemplateCategory',
  components: {
    BaseModal,
    BaseConfirm,
    BaseToast,
    LoadingV2026
  },
  data () {
    return {
      // version2026: FALSE restores today's bootstrap page verbatim — the .table-bordered table,
      // the b-modal with its native <form> + SUBMIT button, and all four $swal dialogs.
      // Flipping this boolean is the entire rollback.
      useV2026MessageTemplateCategorySettings: true,
      modalOpen: false,
      isLoading: false,
      isSaving: false,
      loadError: '',
      nameError: '',
      isNarrow: false,
      confirm: {
        open: false,
        target: null,
        busy: false
      },
      toast: {
        open: false,
        variant: 'success',
        title: '',
        message: ''
      },
      categories: [],
      mode: 'create',
      category: {
        name: ''
      }
    }
  },
  computed: {
    showRows () {
      return this.categories.length > 0
    }
  },
  methods: {
    async fetchV2026 () {
      this.isLoading = true
      this.loadError = ''
      try {
        const { data } = await axios.get('/message-template-categories')
        // Every endpoint answers HTTP 200; data.code is the only success signal.
        if (data.code !== 200) throw new Error(data.message || 'เกิดข้อผิดพลาด')
        this.categories = data.categories || []
      } catch (err) {
        this.loadError = (err && err.message) || 'เกิดข้อผิดพลาด'
        this.showToast('danger', 'โหลดหมวดหมู่ไม่สำเร็จ', this.loadError)
      } finally {
        this.isLoading = false
      }
    },
    openCreateV2026 () {
      this._returnFocusEl = document.activeElement
      this.mode = 'create'
      // Clear the id too — a previous edit leaves it behind and only `mode` keeps POST from being PUT.
      this.category = { name: '' }
      this.nameError = ''
      this.modalOpen = true
      this.$nextTick(() => {
        if (this.$refs.catNameInput) this.$refs.catNameInput.focus()
      })
    },
    openEditV2026 (category) {
      this._returnFocusEl = document.activeElement
      this.mode = 'edit'
      this.category = JSON.parse(JSON.stringify(category))
      this.nameError = ''
      this.modalOpen = true
      this.$nextTick(() => {
        if (!this.$refs.catNameInput) return
        this.$refs.catNameInput.focus()
        this.$refs.catNameInput.select()
      })
    },
    closeModalV2026 () {
      this.modalOpen = false
      this.nameError = ''
      this.focusBack()
    },
    // Replaces the native reportValidity() bubble: the flag-ON branch has no <form>.
    validateNameV2026 () {
      const name = String(this.category.name || '').trim()
      if (!name) {
        this.nameError = 'กรุณาระบุชื่อหมวดหมู่'
        this.$nextTick(() => {
          if (this.$refs.catNameInput) this.$refs.catNameInput.focus()
        })
        return null
      }
      return name
    },
    async submitV2026 () {
      const name = this.validateNameV2026()
      if (!name) return

      const isEdit = this.mode === 'edit'
      const option = {
        method: isEdit ? 'PUT' : 'POST',
        url: isEdit ? '/message-template-categories/' + this.category.id : '/message-template-categories',
        data: { name }
      }

      this.isSaving = true
      try {
        const { data } = await axios(option)
        if (data.code === 200) {
          this.closeModalV2026()
          this.showToast('success', isEdit ? 'บันทึกการแก้ไขแล้ว' : 'สร้างหมวดหมู่แล้ว', '')
          this.fetchV2026()
        } else {
          // The modal stays open so a typed name is never lost.
          this.showToast('danger', 'บันทึกไม่สำเร็จ', data.message || 'เกิดข้อผิดพลาด')
        }
      } catch (err) {
        this.showToast('danger', 'บันทึกไม่สำเร็จ', (err && err.message) || 'เกิดข้อผิดพลาด')
      } finally {
        this.isSaving = false
      }
    },
    openDeleteV2026 (category) {
      this._returnFocusEl = document.activeElement
      this.confirm = { open: true, target: category, busy: false }
    },
    cancelDeleteV2026 () {
      this.confirm = { open: false, target: null, busy: false }
      this.focusBack()
    },
    async acceptDeleteV2026 () {
      const target = this.confirm.target
      if (!target) return

      this.confirm.busy = true
      let removed = false
      try {
        const { data } = await axios.delete('/message-template-categories/' + target.id)
        if (data.code === 200) {
          removed = true
          this.showToast('success', 'ลบหมวดหมู่แล้ว', '')
          this.fetchV2026()
        } else {
          this.showToast('danger', 'ลบไม่สำเร็จ', data.message || 'เกิดข้อผิดพลาด')
        }
      } catch (err) {
        this.showToast('danger', 'ลบไม่สำเร็จ', (err && err.message) || 'เกิดข้อผิดพลาด')
      } finally {
        // Closed on failure too: on an API that answers 200 for everything, leaving a destructive
        // dialog open after an ambiguous failure invites a double-fire.
        this.confirm = { open: false, target: null, busy: false }
        // The invoking row no longer exists once the delete succeeded.
        if (removed) this._returnFocusEl = this.$refs.addBtn || null
        this.focusBack()
      }
    },
    createdAtText (item) {
      // Reuses the global filter without touching filters.js; a blank cell reads as broken.
      return this.$options.filters.prettyDate(item.created_at) || '—'
    },
    showToast (variant, title, message) {
      this.toast = { open: true, variant, title, message }
    },
    focusBack () {
      const el = this._returnFocusEl
      this._returnFocusEl = null
      this.$nextTick(() => {
        if (el && typeof el.focus === 'function') el.focus()
      })
    },
    // The viewport lies on this route: the settings menu collapses at 992px, so the page is WIDER
    // at 900px than at 1024px. Measure the list element.
    measureLayout () {
      const el = this.$refs.catList
      if (el) this.isNarrow = el.clientWidth < 640
    },
    // BaseModal does not trap focus, and the edit dialog is modal.
    trapTab (e, refName) {
      const root = this.$refs[refName]
      if (!root) return
      const sel = 'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      const items = Array.prototype.slice.call(root.querySelectorAll(sel))
      if (!items.length) return
      const first = items[0]
      const last = items[items.length - 1]
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    },
    async fetchCategory () {
      if (this.useV2026MessageTemplateCategorySettings) {
        await this.fetchV2026()
        return
      }
      let { data } = await axios.get('/message-template-categories')
      this.categories = data.categories
    },
    addCategory () {
      if (this.useV2026MessageTemplateCategorySettings) {
        this.openCreateV2026()
        return
      }
      this.mode = 'create'
      this.category.name = null
      this.$refs.categoryModal.show()
    },
    editCategory (category) {
      if (this.useV2026MessageTemplateCategorySettings) {
        this.openEditV2026(category)
        return
      }
      this.mode = 'edit'
      this.category = JSON.parse(JSON.stringify(category))
      this.$refs.categoryModal.show()
    },
    async handleSubmit () {
      if (this.useV2026MessageTemplateCategorySettings) {
        await this.submitV2026()
        return
      }
      if (!this.$refs.form.reportValidity()) {
        return
      }
      const option = {
        method: 'POST',
        url: '/message-template-categories',
        data: {
          name: this.category.name
        }
      }

      if (this.mode === 'edit') {
        option.method = 'PUT'
        option.url = '/message-template-categories/' + this.category.id
      }

      try {
        let { data } = await axios(option)
        this.$swal({ text: data.message, icon: 'success' })
        this.fetchCategory()
        this.$refs.categoryModal.hide()
      } catch (err) {
        this.$swal({ text: err.message })
      }
    },
    async deleteCategory (category) {
      if (this.useV2026MessageTemplateCategorySettings) {
        this.openDeleteV2026(category)
        return
      }
      this.$swal({
        text: 'คุณต้องการลบหมวดหมู่หรือไม่',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            let { data } = await axios.delete('/message-template-categories/' + category.id)
            this.$swal({ text: data.message, icon: 'success' })
            this.fetchCategory()
            this.$refs.categoryModal.hide()
          } catch (err) {
            this.$swal({ text: err.message })
          }
        }
      })
    }
  },
  mounted () {
    if (!this.useV2026MessageTemplateCategorySettings) return
    this.$nextTick(this.measureLayout)
    if (typeof ResizeObserver !== 'undefined') {
      this.$nextTick(() => {
        if (!this.$refs.catList) return
        this._ro = new ResizeObserver(this.measureLayout)
        this._ro.observe(this.$refs.catList)
      })
    }
    window.addEventListener('resize', this.measureLayout)
  },
  beforeDestroy () {
    if (this._ro) {
      this._ro.disconnect()
      this._ro = null
    }
    window.removeEventListener('resize', this.measureLayout)
  },
  created () {
    this.fetchCategory()
  }
}
</script>

<style lang="scss" scoped>

/* Only the ten --v2026-color-* tokens declared on .v2026-shell resolve under /settings, so every
   grey below is hard-coded on purpose. */
.v2026-cat {
  padding: 16px 16px 48px;
  background: #ffffff;
  /* NO overflow: .v2026-settings-content must stay the only vertical scroller. */
}

.v2026-cat-crumb {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #66696C;
}

.v2026-cat-crumb__link {
  color: var(--v2026-color-main);
  text-decoration: none;

  &:hover { text-decoration: underline; }
  &:focus-visible {
    outline: none;
    border-radius: 4px;
    box-shadow: 0 0 0 3px rgba(49, 193, 215, .30);
  }
}

.v2026-cat-crumb__sep { color: #E4E7EC; }

.v2026-cat-title {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
  color: #212529;
}

.v2026-cat-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 0 8px;
}

.v2026-cat-list {
  /* 156px, not the sibling's 132px: measured in the browser, แก้ไข is 76px and ลบ is 64px, so
     132px forces the two buttons onto separate lines and the row grows from 56px to 93px. */
  --cat-cols: minmax(0, 1fr) 170px 156px;
  border-top: 1px solid #e9ecef;

  &.is-narrow { --cat-cols: minmax(0, 1fr) auto; }
  /* The element stays mounted while empty so the ResizeObserver keeps a target. */
  &.is-empty { border-top: 0; }
}

.v2026-cat-head {
  position: sticky;
  top: 0;
  z-index: 2;
  display: grid;
  grid-template-columns: var(--cat-cols);
  column-gap: 16px;
  align-items: center;
  height: 40px;
  padding: 0 8px;
  background: #ffffff;
  border-bottom: 1px solid #e9ecef;
  font-size: 12px;
  font-weight: 600;
  color: #66696C;

  .v2026-cat-list.is-narrow & { column-gap: 12px; }
}

.v2026-cat-row {
  display: grid;
  grid-template-columns: var(--cat-cols);
  column-gap: 16px;
  align-items: center;
  min-height: 56px;
  padding: 10px 8px;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 150ms ease;

  &:hover { background: var(--v2026-color-hover-bg); }
  &:last-child { border-bottom: 0; }

  .v2026-cat-list.is-narrow & {
    grid-template-areas: "name act" "date act";
    column-gap: 12px;
    row-gap: 4px;
    align-items: start;
  }
}

/* grid-area is applied ONLY in the narrow tier: grid-template-areas exists there and nowhere else,
   and an unmatched area name would place the cell in an implicit column instead. The wide tier
   relies on auto-placement, which follows DOM order. */
.v2026-cat-name {
  min-width: 0;
  font-size: 14px;
  color: #212529;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  .v2026-cat-list.is-narrow & { grid-area: name; }
}

.v2026-cat-date {
  font-size: 13px;
  color: #66696C;
  white-space: nowrap;

  .v2026-cat-list.is-narrow & { grid-area: date; }
}

.v2026-cat-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;

  .v2026-cat-list.is-narrow & { grid-area: act; align-self: center; }
}

.v2026-cat-btn-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  font-size: 13px;
  color: #212529;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) { background: var(--v2026-color-hover-bg); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
  &:disabled { opacity: .5; cursor: default; }
}

.v2026-cat-btn-row--danger {
  color: #E5484D;

  &:hover:not(:disabled) { background: #FEF2F2; border-color: rgba(229, 72, 77, .40); }
}

.v2026-cat-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: var(--v2026-color-main);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) { filter: brightness(.94); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
  &:disabled { opacity: .5; cursor: default; }
}

.v2026-cat-btn-ghost {
  height: 36px;
  padding: 0 14px;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  color: #212529;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) { background: var(--v2026-color-hover-bg); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
  &:disabled { opacity: .5; cursor: default; }
}

.v2026-cat-ico {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: var(--v2026-color-icon-idle);
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
}

.v2026-cat-ico--plus {
  background-color: #ffffff;
  -webkit-mask-image: url('~@/assets/icons2026/plus.svg');
          mask-image: url('~@/assets/icons2026/plus.svg');
}

.v2026-cat-ico--edit {
  -webkit-mask-image: url('~@/assets/icons2026/pencil-edit.svg');
          mask-image: url('~@/assets/icons2026/pencil-edit.svg');
}

.v2026-cat-ico--trash {
  background-color: #E5484D;
  -webkit-mask-image: url('~@/assets/icons2026/trash.svg');
          mask-image: url('~@/assets/icons2026/trash.svg');
}

.v2026-cat-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  /* Roughly head + three rows, so the swap to rows or to the empty state barely moves the page. */
  min-height: 208px;
}

.v2026-cat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 56px 16px;
}

.v2026-cat-empty__ico {
  width: 40px;
  height: 40px;
  background-color: #66696C;
  opacity: .55;
  -webkit-mask: url('~@/assets/icons2026/tag.svg') center / contain no-repeat;
          mask: url('~@/assets/icons2026/tag.svg') center / contain no-repeat;
}

.v2026-cat-empty__title {
  font-size: 15px;
  font-weight: 600;
  color: #212529;
}

.v2026-cat-empty__msg {
  font-size: 13px;
  color: #66696C;
  max-width: 420px;
}

.v2026-cat-empty__act { margin-top: 8px; }

.v2026-cat-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

/* ── create / edit modal ────────────────────────────────────── */

.v2026-catm {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
}

.v2026-catm__head {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 56px;
  padding: 0 20px;
  border-bottom: 1px solid #e9ecef;
}

.v2026-catm__title {
  font-size: 15px;
  font-weight: 600;
  color: #212529;
}

.v2026-catm__x {
  margin-left: auto;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: none;
  font-size: 18px;
  line-height: 1;
  color: #66696C;
  cursor: pointer;

  &:hover { background: var(--v2026-color-hover-bg); color: #212529; }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
}

.v2026-catm__body { padding: 20px; }

.v2026-catm__label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #343a40;
}

.v2026-catm__req { color: #E5484D; }

.v2026-catm__input {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  color: #212529;

  &::placeholder { color: #66696C; }
  &:focus {
    outline: none;
    border-color: var(--v2026-color-main);
    box-shadow: 0 0 0 3px rgba(49, 193, 215, .30);
  }
  &.is-invalid {
    border-color: #E5484D;

    &:focus { border-color: #E5484D; box-shadow: 0 0 0 3px rgba(229, 72, 77, .20); }
  }
}

.v2026-catm__err {
  margin-top: 6px;
  font-size: 12px;
  color: #E5484D;
}

.v2026-catm__foot {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  height: 64px;
  padding: 0 20px;
  border-top: 1px solid #e9ecef;
}

@media (prefers-reduced-motion: reduce) {
  .v2026-cat-row { transition: none; }
}
</style>
